export const config = {
    api: {
        baseUrl: process.env.NODE_ENV === 'production'
            ? 'https://pccenter.bg'
            : 'http://localhost:8000',
    },
    // Alias for backward compatibility
    apiUrl: process.env.NODE_ENV === 'production'
        ? 'https://pccenter.bg'
        : 'http://localhost:8000'
} as const;